import { MarketResearchCompensationSummaryData, MarketResearchDiversitySummaryData, MarketResearchHiringDifficultySummaryData, MarketResearchSummaryData, SummaryRating } from "../../features";
import { convertMarketResearchSupplyDemandSummaryResponse, convertNormalizedJobTitle, MarketResearchCompensationSummaryResponse, MarketResearchDiversitySummaryResponse, MarketResearchHiringDifficultySummaryResponse, MarketResearchSummaryResponse } from ".";

export const convertMarketResearchSummaryResponse = (
    res: MarketResearchSummaryResponse
) => {
    if (!res) return null;
    const result: MarketResearchSummaryData = {
        locationId: res.locationId,
        locationName: res.locationName,
        jobTitle: convertNormalizedJobTitle(res.normalizedJobTitle),
        hiringDifficulty: convertMarketResearchHiringDifficultyResponse(res.hiringDifficultySummary),
        compensation: convertMarketResearchCompensationSummaryResponse(res.compensationSummary),
        supplyDemand: convertMarketResearchSupplyDemandSummaryResponse(res.supplyDemandSummary),
        diversity: convertMarketResearchDiversitySummaryResponse(res.diversitySummary),
    };
    return result;
};

const convertMarketResearchCompensationSummaryResponse = (
    res: MarketResearchCompensationSummaryResponse
): MarketResearchCompensationSummaryData => {
    if (!res) return null;

    return {
        medianSalaryInUSDollars: res.medianSalaryInUSDollars,
        annualSalaryInUSDollars: res.annualSalaryInUSDollars,
        rating: !!res?.ratingTypeId ? SummaryRating.fromId(res.ratingTypeId) : null,
    };
};

const convertMarketResearchDiversitySummaryResponse = (
    res: MarketResearchDiversitySummaryResponse
): MarketResearchDiversitySummaryData => {
    if (!res) return null;

    return {
        regionalPercent: res.regionalPercent,
        statePercent: res.statePercent,
        rating: SummaryRating.fromId(res.ratingTypeId),
    };
};

const convertMarketResearchHiringDifficultyResponse = (
    res: MarketResearchHiringDifficultySummaryResponse
): MarketResearchHiringDifficultySummaryData => {
    if (!res) return null;

    return {
        score: res.score,
        rating: SummaryRating.fromId(res.ratingTypeId),
    };
};
